import script from "./PolicyEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyEdit.vue?vue&type=script&setup=true&lang=js"

import "./PolicyEdit.vue?vue&type=style&index=0&id=17da0ebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17da0ebc"]])

export default __exports__